module.exports = __webpack_public_path__ + "static/media/sweet_2_tablet.8d7b152c.png";